module.exports = __webpack_public_path__ + "img/0a9bc2732006ad4684283751731da95.6ae8ad03.jpg";